
export default class TEData {
    id: number;
    name: string;
    invoiceId: number;
}


// WEBPACK FOOTER //
// ./src/models/AP/TEData.ts